import { NgModule } from '@angular/core';

import {
  CoreUiModule,
} from 'webcommon/core-ui';

import {
  FileExtension,
  PatientDocumentsComponent,
  PatientDocumentViewerModalComponent,
} from './documents/index';

import {
  PatientDemographicsModalComponent,
} from './patientdemographics/index';
import { ReviewPastNotesComponent } from './review-past-notes/index';
import { CommonModule, DatePipe } from '@angular/common';
import { FcItemConfig, FindControlModule, ModalSizeEnum } from 'webcommon/find-control';
import { ViewOptionFormComponent , ViewOptionModalComponent } from './view-option/index';
import { CompleteChartPrintComponent , CompleteChartPrintModalComponent} from './complete-chart-print/index';
import { PasswordProtectionZipModalComponent } from './password-protection-zip-modal';
import { SendDocumentModalComponent } from './send-document-modal';
import { SendDocumentComponent } from './send-document';
import { FindControlIdService } from 'webcommon/legacy-common';

const modalComponents = [
  PatientDemographicsModalComponent,
  PatientDocumentViewerModalComponent,
  CompleteChartPrintModalComponent,
  ViewOptionModalComponent,
  PasswordProtectionZipModalComponent,
  SendDocumentModalComponent
];

const pipes = [
  FileExtension,
];

const exportComponents = [
  ...pipes,
  PatientDocumentsComponent,
  ReviewPastNotesComponent,
  ViewOptionFormComponent,
  CompleteChartPrintComponent,
  SendDocumentComponent
];

const declareComponents = [
  ...exportComponents,
  ...modalComponents,
];

@NgModule({
  declarations: [
    declareComponents,
  ],
  imports: [
    CoreUiModule,
    CommonModule,
    FindControlModule
  ],
  exports: [
    ...exportComponents,
  ],
  providers: [
    DatePipe,
  ]
})
export class PatientModule {
  constructor(
    findControlIdService: FindControlIdService,
    fcItemConfig: FcItemConfig
  ) {
     fcItemConfig.registerItemModal(
      findControlIdService.ListRPNOptions,
      ViewOptionModalComponent,
      ModalSizeEnum.medium
    );
  }
}
